import { comingSoon } from './coming-soon';
import { initJoinSession } from './join-session';
import { initFeedbackSubmit } from './feedback-submit';
import { initDueCode } from './due-code';
import { initDoneStage } from './done-stage';
import initNotiSettings from './noti-settings';

export function actions() {
	comingSoon();
	initDoneStage();
	initJoinSession();
	initFeedbackSubmit();
	initDueCode();
	initNotiSettings();
}
